export default __webpack_public_path__ + "static/media/video.8a63c515.svg";